// http/authConfig.ts
import { LogLevel, Configuration } from '@azure/msal-browser';

// Browser check variables
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const msedge = ua.indexOf('Edge/');
const firefox = ua.indexOf('Firefox');
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;


// App registration client id
const itsid = '43a1f395-3dcc-4f93-9b5f-64d16474421c';

// 🚨 NYTT: bruk alltid faktisk host som baseUri
const baseUri = window.location.origin;

// MSAL config (typet)
export const itsConfig: Configuration = {
  auth: {
    clientId: itsid,
    authority: 'https://login.microsoftonline.com/common', // ✔  multi-tenant
    redirectUri: `${baseUri}/blank.html`,
    postLogoutRedirectUri: baseUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
      logLevel: LogLevel.Info,
    },
  },
};

// Scopes for token requests
const apiAppIdUri = `api://${itsid}`;

export const itsRequest = {
  scopes: [`${apiAppIdUri}/access_as_user`],
};
